interface QueryElement<T extends Element> {
    scrollToY(targetY: number, speed: number, easing: (pos:number) => number): void;
}

QueryElement.prototype.scrollToY = function(
    targetY: number, 
    speed: number, 
    easing: (pos: number) => number) {
    
    let elem = this.get();
    let scrollTop = elem.scrollTop;

    let time = Math.max(.1, Math.min(Math.abs(scrollTop - targetY) / speed, .8));
    let currentTime = 0;
    
    function tick() {
        currentTime += 1 / 60;

        let p = currentTime / time;
        let t = easing(p);

        if (p < 1) {
            window.requestAnimationFrame(tick);
            elem.scrollTop = scrollTop + ((targetY - scrollTop) * t);
        } else {
            elem.scrollTop = targetY;
        }
    }

    tick();
}

class Easing {
    static easeOutCubic(pos: number) {
        return (--pos)*pos*pos+1;
    }
    static easeOutQuad(pos: number) {
        return 1-(--pos)*pos*pos*pos;
    }
    static easeOutSine(pos: number) {
        return Math.sin(pos * (Math.PI / 2));
    }
    static easeInOutSine(pos: number) {
        return (-0.5 * (Math.cos(Math.PI * pos) - 1));
    }
    static easeInOutQuint(pos: number) {
        if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 5);
        }
        return 0.5 * (Math.pow((pos - 2), 5) + 2);
    }
}